import { useState } from "react";

import {
  closeModalDialog,
  showSnackNotificationAction,
} from "../../../../../actions/layoutActions";
import useActions from "../../../../hooks/useActions";
import { useIsMounted } from "../../../../hooks/useIsMounted";

export const useSubmittalSave = onSaveSuccess => {
  const [isSaving, setIsSaving] = useState(false);
  const isMounted = useIsMounted();
  const actions = useActions({ showSnackNotificationAction, closeModalDialog });

  const save = async run => {
    setIsSaving(true);
    try {
      await run();
      actions.showSnackNotificationAction(
        "The submittals have been saved successfully"
      );
      (onSaveSuccess || actions.closeModalDialog)();
    } catch (error) {
      actions.showSnackNotificationAction(
        error?.title || error?.message || "The submittals could not be saved"
      );
    } finally {
      if (isMounted()) setIsSaving(false);
    }
  };

  return { isSaving, save };
};
